import React, {PropTypes as T} from 'react';
import Button from '../../common/button';
import InputText from '../../common/input_text';
import UnlockIcon from '../../common/icons/icon_unlock';
import LoadingIcon from '../../common/icons/icon_loading';
import basketActions from '../../../actions/basket';
import translate from '../../../utils/translate';

export default class PasswordBox extends React.Component {
  static propTypes = {
    priceType: T.shape({
      number: T.number.isRequired,
      isUnlocked: T.bool.isRequired,
      unlockingErrors: T.object
    }),
    eventId: T.string.isRequired,
    isUnlockingPriceType: T.oneOfType([T.bool, T.number])
  };

  state = {
    passwordText: ''
  };

  passwordInputChange = (value) => {
    if (this.props.priceType.unlockingErrors) {
      basketActions.clearUnlockPriceTypePasswordErrors(this.props.priceType.number);
    }
    this.setState({ passwordText: value });
  };

  unlock = (e) => {
    e.preventDefault();
    basketActions.unlockPriceType({
      eventId: this.props.eventId,
      priceTypeId: this.props.priceType.number,
      password: this.state.passwordText
    });
    return false;
  };

  render () {
    const { priceType, isUnlockingPriceType } = this.props;
    let errorMsg = '';

    if (priceType.unlockingErrors) {
      switch (priceType.unlockingErrors.error) {
        case 'invalidPassword':
          errorMsg = translate('ismModule', 'PASSWORD_INVALID_INFO');
          break;
        case 'usedPassword':
          errorMsg = translate('ismModule', 'PASSWORD_USED_INFO');
          break;
        case 'promotionNotStarted':
          errorMsg = translate('ismModule', 'PASSWORD_PROMOTION_NOT_STARTED_INFO');
          break;
        default:
          errorMsg = translate('ismModule', 'PASSWORD_ERROR_INFO');
      }
    }

    return (
      <form onSubmit={this.unlock} action="javascript:void(0)" className="passwordBox">
        <InputText
          className="passwordBox__input"
          placeholder={translate('ismModule', 'UNLOCK_INPUT_PLACEHOLDER')}
          autoFocus
          autoComplete="off"
          stateError={!!priceType.unlockingErrors}
          stateValid={priceType.isUnlocked}
          errorMessage={priceType.unlockingErrors && errorMsg}
          value={this.state.passwordText}
          onChange={this.passwordInputChange}
          data-component="password-field" />
        <Button
          primary
          type="submit"
          className="passwordBox__btn"
          disabled={this.state.passwordText.length === 0 || !!isUnlockingPriceType}
          onClick={this.unlock}
          data-component="password-submit-button">
          {
            (isUnlockingPriceType && this.props.isUnlockingPriceType === priceType.number)
            ? <LoadingIcon className="passwordBox__unlock" width={20} />
            : <UnlockIcon className="passwordBox__unlock" width={20} />
          }
        </Button>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/edp/passwordbox/index.js